<div class="custom-snack-bar-container">
  <span class="snack-message" [innerHTML]="data"></span>
  <button mat-icon-button class="snack-close" (click)="closeSnackBar()">
    <mat-icon class="material-symbols-rounded">close</mat-icon>
  </button>
</div>
